import { createSlice } from '@reduxjs/toolkit'
import { setLoadedDone, setLoading } from '../reducers'
import { STATUS } from '../../enums/common'

const personSlice = createSlice({
  name: 'person',
  initialState: {
    status: STATUS.idle,
  },
  reducers: {
    personPending: setLoading,
    personLoaded: setLoadedDone,
  },
})

const { actions, reducer } = personSlice
export const personActions = actions

export default reducer
